var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _rect3, _path6, _rect4, _path7, _rect5, _g, _rect6, _rect7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemCustomFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 92,
    viewBox: "0 0 89 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 88,
    height: 80,
    rx: 20,
    fill: "#E7F4FD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 0.5,
    width: 63,
    height: 83,
    rx: 3.5,
    fill: "white",
    stroke: "#EEEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 8.20068H41.5",
    stroke: "#E0E2E7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 8.20068H66.5",
    stroke: "#E0E2E7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12.8674H36.5",
    stroke: "#E0E2E7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 12.8674H61.5",
    stroke: "#E0E2E7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.8674H36.5",
    stroke: "#C2C6CE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 28,
    width: 38,
    height: 6,
    rx: 1,
    stroke: "#0C8CE9",
    strokeDasharray: "2 2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 42.8674H36.5",
    stroke: "#C2C6CE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 48,
    width: 46,
    height: 6,
    rx: 1,
    fill: "#F0F1F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 64.8674H36.5",
    stroke: "#C2C6CE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 70,
    width: 46,
    height: 6,
    rx: 1,
    fill: "#F0F1F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2464_154698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0139 46.8534C50.8272 46.6134 50.5939 46.1267 50.1872 45.52C49.9539 45.1867 49.3806 44.5534 49.2072 44.2267C49.0823 44.0282 49.046 43.7865 49.1072 43.56C49.2119 43.1295 49.6203 42.8439 50.0606 42.8934C50.4011 42.9618 50.714 43.1287 50.9606 43.3734C51.1327 43.5355 51.291 43.7116 51.4339 43.9C51.5406 44.0334 51.5672 44.0867 51.6872 44.24C51.8072 44.3934 51.8872 44.5467 51.8272 44.32C51.7806 43.9867 51.7006 43.4267 51.5872 42.9267C51.5006 42.5467 51.4806 42.4867 51.4006 42.2C51.3206 41.9134 51.2739 41.6734 51.1872 41.3467C51.108 41.0257 51.0457 40.7009 51.0006 40.3734C50.9165 39.9545 50.9777 39.5195 51.1739 39.14C51.4068 38.9209 51.7485 38.8631 52.0406 38.9934C52.3343 39.2103 52.5533 39.5131 52.6672 39.86C52.8419 40.287 52.9585 40.7354 53.0139 41.1934C53.1206 41.86 53.3272 42.8334 53.3339 43.0334C53.3339 42.7867 53.2872 42.2667 53.3339 42.0334C53.3801 41.7901 53.5492 41.5882 53.7806 41.5C53.9791 41.4391 54.1891 41.4254 54.3939 41.46C54.6006 41.5032 54.7837 41.6221 54.9072 41.7934C55.0617 42.1823 55.1474 42.5951 55.1606 43.0134C55.1784 42.6471 55.2411 42.2844 55.3472 41.9334C55.4586 41.7764 55.6213 41.6632 55.8072 41.6134C56.0276 41.5731 56.2535 41.5731 56.4739 41.6134C56.6546 41.6738 56.8127 41.7877 56.9272 41.94C57.0684 42.2936 57.1539 42.6669 57.1806 43.0467C57.1806 43.14 57.2272 42.7867 57.3739 42.5534C57.4501 42.3271 57.6413 42.1587 57.8753 42.1116C58.1094 42.0644 58.3508 42.1457 58.5087 42.3249C58.6665 42.504 58.7168 42.7538 58.6406 42.98C58.6406 43.4134 58.6406 43.3934 58.6406 43.6867C58.6406 43.98 58.6406 44.24 58.6406 44.4867C58.6163 44.8768 58.5628 45.2646 58.4806 45.6467C58.3645 45.9848 58.2031 46.3055 58.0006 46.6C57.6769 46.96 57.4094 47.3668 57.2072 47.8067C57.1571 48.0252 57.1347 48.2492 57.1406 48.4734C57.1399 48.6805 57.1668 48.8867 57.2206 49.0867C56.948 49.1155 56.6731 49.1155 56.4006 49.0867C56.1406 49.0467 55.8206 48.5267 55.7339 48.3667C55.691 48.2808 55.6033 48.2265 55.5072 48.2265C55.4112 48.2265 55.3234 48.2808 55.2806 48.3667C55.1339 48.62 54.8072 49.08 54.5806 49.1067C54.1339 49.16 53.2139 49.1067 52.4872 49.1067C52.4872 49.1067 52.6072 48.44 52.3339 48.2C52.0606 47.96 51.7806 47.68 51.5739 47.4934L51.0139 46.8534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0139 46.8534C50.8272 46.6134 50.5939 46.1267 50.1872 45.52C49.9539 45.1867 49.3806 44.5534 49.2072 44.2267C49.0823 44.0282 49.046 43.7865 49.1072 43.56C49.2119 43.1295 49.6203 42.8439 50.0606 42.8934C50.4011 42.9618 50.714 43.1287 50.9606 43.3734C51.1327 43.5355 51.291 43.7116 51.4339 43.9C51.5406 44.0334 51.5672 44.0867 51.6872 44.24C51.8072 44.3934 51.8872 44.5467 51.8272 44.32C51.7806 43.9867 51.7006 43.4267 51.5872 42.9267C51.5006 42.5467 51.4806 42.4867 51.4006 42.2C51.3206 41.9134 51.2739 41.6734 51.1872 41.3467C51.108 41.0257 51.0457 40.7009 51.0006 40.3734C50.9165 39.9545 50.9777 39.5195 51.1739 39.14C51.4068 38.9209 51.7485 38.8631 52.0406 38.9934C52.3343 39.2103 52.5533 39.5131 52.6672 39.86C52.8419 40.287 52.9585 40.7354 53.0139 41.1934C53.1206 41.86 53.3272 42.8334 53.3339 43.0334C53.3339 42.7867 53.2872 42.2667 53.3339 42.0334C53.3801 41.7901 53.5492 41.5882 53.7806 41.5C53.9791 41.4391 54.1891 41.4254 54.3939 41.46C54.6006 41.5032 54.7837 41.6221 54.9072 41.7934C55.0617 42.1823 55.1474 42.5951 55.1606 43.0134C55.1784 42.6471 55.2411 42.2844 55.3472 41.9334C55.4586 41.7764 55.6213 41.6632 55.8072 41.6134C56.0276 41.5731 56.2535 41.5731 56.4739 41.6134C56.6546 41.6738 56.8127 41.7877 56.9272 41.94C57.0684 42.2936 57.1539 42.6669 57.1806 43.0467C57.1806 43.14 57.2272 42.7867 57.3739 42.5534C57.4501 42.3271 57.6413 42.1587 57.8753 42.1116C58.1094 42.0644 58.3508 42.1457 58.5087 42.3249C58.6665 42.504 58.7168 42.7538 58.6406 42.98C58.6406 43.4134 58.6406 43.3934 58.6406 43.6867C58.6406 43.98 58.6406 44.24 58.6406 44.4867C58.6163 44.8768 58.5628 45.2646 58.4806 45.6467C58.3645 45.9848 58.2031 46.3055 58.0006 46.6C57.6769 46.96 57.4094 47.3668 57.2072 47.8067C57.1571 48.0252 57.1347 48.2492 57.1406 48.4734C57.1399 48.6805 57.1668 48.8867 57.2206 49.0867C56.948 49.1155 56.6731 49.1155 56.4006 49.0867C56.1406 49.0467 55.8206 48.5267 55.7339 48.3667C55.691 48.2808 55.6033 48.2265 55.5072 48.2265C55.4112 48.2265 55.3234 48.2808 55.2806 48.3667C55.1339 48.62 54.8072 49.08 54.5806 49.1067C54.1339 49.16 53.2139 49.1067 52.4872 49.1067C52.4872 49.1067 52.6072 48.44 52.3339 48.2C52.0606 47.96 51.7806 47.68 51.5739 47.4934L51.0139 46.8534Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.666 47.2173V44.9162C56.666 44.7784 56.5541 44.6667 56.416 44.6667C56.2779 44.6667 56.166 44.7784 56.166 44.9162V47.2173C56.166 47.3551 56.2779 47.4667 56.416 47.4667C56.5541 47.4667 56.666 47.3551 56.666 47.2173Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3473 47.2165L55.334 44.9141C55.3332 44.7767 55.2206 44.666 55.0825 44.6668C54.9445 44.6675 54.8332 44.7796 54.834 44.917L54.8473 47.2194C54.8481 47.3568 54.9607 47.4675 55.0988 47.4667C55.2368 47.466 55.3481 47.3539 55.3473 47.2165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 44.9194L53.5133 47.217C53.5141 47.3557 53.6267 47.4676 53.7648 47.4667C53.9029 47.4659 54.0141 47.3528 54.0133 47.2141L54 44.9165C53.9992 44.7778 53.8866 44.6659 53.7485 44.6668C53.6105 44.6676 53.4992 44.7807 53.5 44.9194Z",
    fill: "black"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 28,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#0C8CE9",
    stroke: "#0C8CE9",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "translate(63.5 29)",
    fill: "#0C8CE9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4993 29.6667C65.5914 29.6667 65.666 29.7414 65.666 29.8334V30.8334H66.666C66.7581 30.8334 66.8327 30.908 66.8327 31.0001C66.8327 31.0921 66.7581 31.1667 66.666 31.1667H65.666V32.1667C65.666 32.2588 65.5914 32.3334 65.4993 32.3334C65.4073 32.3334 65.3327 32.2588 65.3327 32.1667V31.1667H64.3327C64.2406 31.1667 64.166 31.0921 64.166 31.0001C64.166 30.908 64.2406 30.8334 64.3327 30.8334H65.3327V29.8334C65.3327 29.7414 65.4073 29.6667 65.4993 29.6667Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2464_154698",
    x: 44.3,
    y: 35.4667,
    width: 18.4,
    height: 18.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.666667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2464_154698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2464_154698",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemCustomFields);
export default __webpack_public_path__ + "static/media/item_custom_fields.c7e1d8ea80de11d9b8b81537070d93de.svg";
export { ForwardRef as ReactComponent };